export default "__VITE_ASSET__DxbSzdPi__"